<template>
    <div>
        <b-modal id="createEditImageModal" title="Insert Image" size="lg" no-fade no-close-on-backdrop no-close-on-esc no-enforce-focus>
            <template v-if="file_loading">
                <i class="fas fa-cog fa-spin"></i> Loading...
            </template>
            <template v-else>
                <tui-image-editor ref="imgEditor" :include-ui="useDefaultUI" :options="options" v-if="file.id && $root.isImage(file.file_ext)"></tui-image-editor>

                <template v-if="false">
                    <div class="row mt-4 mb-2">
                        <div class="col-md-3 text-md-right">Width:</div>
                        <div class="col-md-8">
                            <div class="input-group">
                                <b-form-input v-model="width" placeholder="Enter Width in pixels"></b-form-input>
                                <div class="input-group-append">
                                    <div class="input-group-text bg-light">px</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 text-md-right">Height:</div>
                        <div class="col-md-8">
                            <div class="alert alert-info">The height is automatically calculated from the width to preserve the aspect ratio.</div>
                        </div>
                    </div>
                </template>
            </template>

            <template v-slot:modal-footer>
                <button class="btn btn-secondary float-left" v-on:click="backToImages()" :disabled="saving">Back to Image Picker</button>

                <button class="btn btn-primary" v-on:click="saveImage(false)" :disabled="saving" title="Saves the Image and Returns to the Image Picker">Update Image <i class="fa fa-spin fa-spinner" v-if="saving"></i></button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import 'tui-image-editor/dist/tui-image-editor.min.css';
    import {ImageEditor} from '@toast-ui/vue-image-editor';

    export default {
        props: {

        },

        components: {
            'tui-image-editor': ImageEditor
        },

        data() {
            return {
                loading: true,
                file_loading: false,
                saving: false,
                id: this.$route.params.id,
                timezone: this.$root.timezone,
                file: {},
                file_name: null,
                width: null,
                errors: {},

                useDefaultUI: true,
            }
        },

        computed: {
            options(){ // for tui-image-editor component's "options" prop
                var options = {
                    includeUI:{
                        loadImage: {
                            path: '',
                            name: 'New Image',
                        },
                        uiSize: {
                            width: '720px',
                            height: '700px'
                        },
                        menu: ['crop', 'flip', 'rotate', 'draw', 'shape', 'icon', 'text'],
                        menuBarPosition: 'top'
                    },
                    cssMaxWidth: 700,
                    cssMaxHeight:800,
                    usageStatistics: false
                };

                //Check for Image
                if(this.file.id && this.file.data_image)
                {
                    options.includeUI.loadImage = {
                        path: this.file.data_image,
                        name: this.file.file_name,
                    };
                }

                //Send it
                return options;
            },

        },

        methods: {

            showModal(file){
                //Set the file
                if(file)
                {
                    //Set the file
                    this.file = file;

                    //Load the FULL image
                    this.getFullSizeImage();
                }

                //Make sure the width is null
                this.width = null;

                //Show it
                this.$bvModal.show('createEditImageModal');
            },

            backToImages(){
                //Hide this
                this.$bvModal.hide('createEditImageModal');

                //Emit to let the parent know to show
                this.$emit('backToImages', true);
            },

            getFullSizeImage(){
                //Loading
                this.file_loading = true;

                //Get the file
                this.$http.get('/files/'+this.file.id, {base64: true, api_view: true})
                    .then(response => {
                        //Set it
                        this.file.data_image = response.data.data_image;
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data.errors;
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.e(error.response.data, 'Failed to Edit File');
                        }
                    })
                    .then(response => {
                        //SHow loading
                        this.file_loading = false;
                    });
            },

            saveImage(insertImage = true){
                //Helpers
                this.saving = true;

                //Get the data
                var file_data = this.$refs.imgEditor.invoke('toDataURL');

                //Helpers
                this.saving = true;

                //Setup
                var filePayload = {
                    id: this.file.id,
                    file_name: this.file_name,
                    file_data: file_data,
                    save_as_new: false,
                    width: this.width,
                };

                //Send it
                this.$http
                .post('files/'+ this.file.id + '/edit', filePayload)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('File Saved');

                    //Emit the image
                    this.$emit('imageSaved', {file: response.data, insertImage: insertImage});

                    //Show it
                    this.$bvModal.hide('createEditImageModal');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Edit File');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });

            },
        },

        mounted() {
            //Get it
            //this.getFile();
        }
    }
</script>
